import { ErrorBoundary } from '@toss/error-boundary';
import { useTranslation } from 'next-i18next';
import { ErrorBoundaryFallback } from '@/components';
import { formatEnglishTitleCase } from '@/utils';
import { ProfileTitleWithMenus } from '../profile/share/ProfileTitleWithMenus';
import { VoucherContainer } from './VoucherContainer';
export const VoucherPage = () => {
  const {
    t,
    i18n
  } = useTranslation(['billing']);
  return <>
      <ProfileTitleWithMenus title={<span className={'text-heading-xl-extrabold text-default'}>
            {formatEnglishTitleCase(t('voucher.title'), i18n.resolvedLanguage)}
          </span>} className={'mb-md py-xs'} hideMobileDropdown data-sentry-element="ProfileTitleWithMenus" data-sentry-source-file="VoucherPage.tsx" />
      <ErrorBoundary renderFallback={({
      error
    }) => <ErrorBoundaryFallback error={error} />} data-sentry-element="ErrorBoundary" data-sentry-source-file="VoucherPage.tsx">
        <VoucherContainer data-sentry-element="VoucherContainer" data-sentry-source-file="VoucherPage.tsx" />
      </ErrorBoundary>
    </>;
};